import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const [inputId, setInputId] = useState('');

  const handleNewUser = () => {
    const newId = crypto.randomUUID();
    localStorage.setItem('userId', newId);
    navigate(`/user/${newId}`);
  };

  const handleExistingUser = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = inputId.trim();
    if (!trimmed) return;
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(trimmed)) {
      alert('Please enter a valid UUID');
      return;
    }
    localStorage.setItem('userId', trimmed);
    navigate(`/user/${trimmed}`);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-primary-500 rounded-2xl mx-auto mb-6 flex items-center justify-center text-3xl shadow-lg shadow-primary-500/25">
            🎯
          </div>
          <h1 className="text-3xl font-bold mb-3 tracking-tight">Accountability Coach</h1>
          <p className="text-slate-400 text-sm leading-relaxed">
            Track your goals, log your progress, and stay accountable every day.
          </p>
        </div>

        <button
          onClick={handleNewUser}
          className="w-full bg-primary-600 hover:bg-primary-500 text-white font-semibold py-4 px-6 rounded-xl transition-colors mb-4 text-base shadow-lg shadow-primary-600/25 active:scale-[0.98] transform"
        >
          Get Started
        </button>

        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-slate-700"></div>
          </div>
          <div className="relative flex justify-center text-xs">
            <span className="px-4 bg-slate-900 text-slate-500 uppercase tracking-wider">or</span>
          </div>
        </div>

        <form onSubmit={handleExistingUser}>
          <label className="block text-sm font-medium text-slate-400 mb-2">Enter your existing ID</label>
          <input
            type="text"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            className="w-full bg-slate-800 border border-slate-700 rounded-xl py-3.5 px-4 text-sm text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent mb-3"
          />
          <button
            type="submit"
            className="w-full bg-slate-800 hover:bg-slate-700 text-white font-medium py-3.5 px-6 rounded-xl transition-colors border border-slate-700 active:scale-[0.98] transform"
          >
            Continue
          </button>
        </form>

        <p className="text-center text-xs text-slate-500 mt-8">
          Bookmark your page after signing in to return anytime.
        </p>
      </div>
    </div>
  );
}
